<template>
<div>

  <div class="hello" :style="{height: height}">
    <div class="box-20150708">
        <!-- <img src="../assets/zm-1.jpg" />
        <img src="../assets/zm-2.jpg" />
        <img src="../assets/zm-3.jpg" /> -->
        <img src="../assets/bg20230615.jpg" alt="" srcset="">
    </div>
  </div>
  <button class="ws-btn" id="linkBtn" @click="linkBtn" >{{msg}}</button>
</div>
</template>

<script>
import {isWeixin} from '../utils/common'
import {checkStatus, getSwitch, wxConfig} from '../utils/actions'
import wx from 'weixin-js-sdk'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '在线报名',
      height: ''
    }
  },
  created () {
    this.height = window.innerHeight + 'px'
    if (isWeixin()) {
      this.wxShare() // 分享功能
    }
  },
  methods: {
    async wxShare () {
      let data = await wxConfig({shareUrl: location.href.split('#')[0].replace('&', '%26')})
      if (data) {
        data.data.jsApiList = [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone'
        ]
        wx.config(data.data)
        let wxData = {
          title: 'e代驾司机招募', // 分享标题
          desc: '高收入，高保障，时间更自由，e代驾欢迎您！', // 分享描述
          link: location.origin + '/driver-app-client/driver-recruit/index.html',
          imgUrl: location.origin + '/chehou/core/img/share.jpg',
          fail: function (res) {
            alert(JSON.stringify(res))
          }
        }
        wx.ready(function () {
          wx.checkJsApi({
            jsApiList: ['onMenuShareAppMessage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function () {
              wx.onMenuShareAppMessage(wxData)
              wx.onMenuShareTimeline(wxData)
              wx.onMenuShareWeibo(wxData)
              wx.onMenuShareQQ(wxData)
              wx.onMenuShareQZone(wxData)
            }
          })
        })
      }
    },
    async linkBtn () {
      let _this = this
      if (!isWeixin()) {
        _this.$router.push({path: 'without-page'})
      } else {
        _this.checkStatus() // 获取状态、
      }
    },
    async checkStatus () {
      let data = await checkStatus({
        open_id: this.$store.state.openid
      })
      if (!data) return
      if (!data.data) {
        this.$router.push({name: 'login'})
        return
      }
      if (data.data.recycle == '1') {//eslint-disable-line
        this.$router.push({name: 'defeat'})
        return
      }
      this.$store.commit('ID', data.data.id) // id
      this.$store.commit('CITYID', data.data.city_id) // cityId
      this.$store.commit('IDCAR', data.data.id_card) // cardId
      this.$store.commit('PHONE', data.data.mobile) // phone
      this.$store.commit('CNAME', data.data.company_name) // 路考分公司
      this.$store.commit('CPHONE', data.data.company_phone) // 分公司电话
      this.$store.commit('WORKTYPE', data.data.driver_work_type || '1') // 司机类型
      let res = await getSwitch({
        open_id: this.$store.state.openid,
        driver_work_type: data.data.driver_work_type || '1'
      })
      console.log(res)
      let needExam = res.data.exam
      switch (data.data.status + '') { // 待完善
        case '1': // 流程第1步报名
          // 报名页面1
          this.$router.push({name: 'signUp', params: {status: data.data.status}})
          break
        case '2': // 报名成功,
          if (needExam) {
            this.$router.push({name: 'recruitAnswer', params: {status: data.data.status}})
          } else {
            this.$router.push({name: 'cardIDUpLoad', params: {status: '5'}})
          }
          break
        case '3': // 考试未通过
        case '4': // 考试通过
          // 答题页 2
          this.$router.push({name: 'recruitAnswer', params: {status: data.data.status}})
          break
        case '5': // 身份证证件未通过
          // 身份证拍照页面
          this.$router.push({name: 'cardIDUpLoad', params: {status: data.data.status}})
          break
        case '6': // 身份证证件通过
        case '7': // 驾驶证未通过
          // 驾驶证拍照页面
          this.$router.push({name: 'licenceLoad', params: {status: data.data.status}})
          break
        case '8': // 驾照验证通过
        case '9': // 面试未邀请
        case '10': // 面试已邀请
        case '11': // 面试未通过
          // 信息审核 5
          this.$router.push({name: 'msgAudit', params: {status: data.data.status}})
          break
        case '12': // 面试通过
        case '13': // 路考未预约
        case '16': // 路考不通过
          // 预约路考页面 6
          this.$router.push({name: 'appointedRoadTest', params: {status: data.data.status}})
          break
        case '14': // 路考已预约-报名完成
        case '15': // 路考进行中
        case '17': // 路考通过
        case '18': // 成功签约
        case '19': // 已领装备
          this.$router.push({name: 'passStatus', params: {status: data.data.status}})
          break
        default:
          break
      }
    }
  }
}
</script>
<style scoped>
.hello{
  background: #000000;
  overflow: hidden;
}
.box-20150708 img{
  width: 100%;
  height: auto;
  vertical-align: middle;
}
.ws-btn{
  padding: 0;
  margin-left:5%;
  width: 90%;
  background: #04a0e9;
  height: .9rem;
  line-height: .9rem;
  font-size: .4rem;
  color: #fff;
  border:none;
  border-radius: .12rem;
  position: fixed;
  bottom: .3rem;
  margin-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  margin-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue